export function viewMoreNews() {
	document.querySelectorAll("[data-view-more]").forEach((list) => {
		const button = list.querySelector(".btn--news");

		if (!button) {
			return;
		}

		const hiddenItems = Array.from(list.querySelectorAll(".post.hide"));
		const label = button.querySelector("span");

		button.addEventListener("click", (e) => {
			e.preventDefault();
			const expanded = !button.classList.contains("is-expanded");

			button.classList.toggle("is-expanded", expanded);
			hiddenItems.forEach((item) => item.classList.toggle("hide", !expanded));
			label.textContent = expanded ? "View Less" : "View More";
		});
	});
}
